module.exports = __webpack_public_path__ + "img/bg_avatar_female_42.b77ce113.png";